// extracted by mini-css-extract-plugin
export default {"container":"tasks-deleted_page_container__yHx28","headerContainer":"tasks-deleted_page_headerContainer__BSkVA"};